import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "./AuthContext";
import { formatApiError } from "./api";
import { Logo } from "../components/Logo";

export function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bienvenido");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Error de acceso");
    } finally {
      setLoading(false);
    }
  };

  const input =
    "w-full border border-[#B2967D]/50 px-4 py-3 bg-white text-black placeholder:text-[#B2967D] focus:outline-none focus:border-[#7D5A44] transition-colors font-light";

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#7D5A44] px-6 font-poppins">
      <div className="w-full max-w-md bg-white p-10">
        <div className="flex justify-center mb-8">
          <Logo heightClass="h-12" />
        </div>
        <h1 className="text-2xl font-bold text-black text-center">Panel administrativo</h1>
        <p className="mt-2 text-sm font-light text-black/50 text-center">Acceso para el equipo administrativo</p>

        <form onSubmit={submit} className="mt-8 space-y-5" data-testid="login-form">
          <div>
            <label className="text-xs font-bold tracking-wide uppercase text-[#B2967D]">Correo</label>
            <input
              data-testid="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="correo@iblvc.com"
              className={`${input} mt-2`}
              required
            />
          </div>
          <div>
            <label className="text-xs font-bold tracking-wide uppercase text-[#B2967D]">Contraseña</label>
            <input
              data-testid="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className={`${input} mt-2`}
              required
            />
          </div>
          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="w-full bg-[#7D5A44] text-white px-8 py-4 text-sm font-bold tracking-wide uppercase hover:bg-black transition-colors duration-300 disabled:opacity-60"
          >
            {loading ? "Ingresando..." : "Ingresar"}
          </button>
        </form>

        <div className="mt-6 flex justify-between text-sm">
          <Link to="/admin/forgot-password" className="font-light text-[#7D5A44] hover:underline" data-testid="forgot-link">
            ¿Olvidaste tu contraseña?
          </Link>
          <Link to="/" className="font-light text-[#B2967D] hover:text-black">
            Volver al sitio
          </Link>
        </div>
      </div>
    </div>
  );
}
